/**
 * Created by alex.y on 8/11/2017.
 */
export enum PdaType{
    Default = 0,
    FDA = 1,
    EPA = 2,
    DOT = 4
}


// WEBPACK FOOTER //
// ./app/objects/orders/PdaType.ts